import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    backgroundColor: theme.palette.background.paper,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  sectionTitle: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.35,
    '&::before': {
      content: '""',
      display: 'inline-block',
      height: 16,
      width: 3,
      backgroundColor: 'red',
      marginRight: 10,
      borderTopLeftRadius: 2,
      position: 'relative',
      top: 2,
    },
  },
  descriptionText: {
    color: theme.palette.text.secondary,
    lineHeight: 1.35,
  },
  formLabel: {
    fontSize: 13,
    lineHeight: 1.4,
    '&.Mui-focused': {
      // color: '#3F4254',
    },
    '& .MuiFormLabel-asterisk': {
      color: 'red',
    },
  },
  examModeAutoTag: {
    color: theme.palette.text.secondary,
    marginLeft: 2,
    fontWeight: 400,
  },
  examModeReadonlyInput: {
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.text.primary,
      WebkitTextFillColor: theme.palette.text.primary,
      opacity: 1,
    },
  },
  examDateTimeTrigger: {
    cursor: 'pointer',
    '& .MuiFormControl-root': {
      pointerEvents: 'none',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.text.primary,
      WebkitTextFillColor: theme.palette.text.primary,
      opacity: 1,
    },
  },
  examDateTimeTriggerDisabled: {
    cursor: 'not-allowed',
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.text.disabled,
      WebkitTextFillColor: theme.palette.text.disabled,
    },
  },
  datePickerNoMarginTop: {
    marginTop: '0 !important',
  },
  checkboxWrapper: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 4,
    padding: '0 14px',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  noChineseNameControl: {
    '& .MuiFormControlLabel-label': {
      color: theme.palette.text.secondary,
    },
    '& .MuiCheckbox-root.Mui-checked + .MuiFormControlLabel-label': {
      color: theme.palette.text.primary,
    },
  },
  summaryText: {
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
  },
  summaryItem: {
    display: 'inline-block',
    marginRight: 16,
  },
  summaryStrong: {
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  summaryQuota: {
    color: 'red',
    fontWeight: 600,
    marginRight: 5,
  },
  regionOption: {
    '&.Mui-selected': {
      fontWeight: 'bold',
    },
    '& > span:first-of-type': {
      minWidth: 40,
      marginRight: 10,
    },
  },
}));
